import axios from "../../axios/index.js"


export default {
   GetAll(no,debut,fin) {
    return axios.get("reporting/listCommande/"+no+"?dateDebut="+debut+"&dateFin="+fin,{headers:{Authorization: 'Bearer '+localStorage.getItem('accessToken')}})
  },
  GetEntete(id) {
     return axios.get("commandes/getentete/"+id,{headers:{Authorization: 'Bearer '+localStorage.getItem('accessToken')}})
  },
  Commander(id,commande) {
    return axios.post("commandes/"+id,commande,{headers:{Authorization: 'Bearer '+localStorage.getItem('accessToken')}})
  },
  GetClients() {
    return axios.get("clients/fromnav",{headers:{Authorization: 'Bearer '+localStorage.getItem('accessToken')}})
  },
  printListeCommande(){
    return axios.get('test') ;
  },
  Get(no){
    console.log(localStorage.getItem("accessToken"))
    return axios.get("/reporting/detail/commande", {params: {code : no}},{ headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
}
}
